const styles = (theme) => ({
  container: {
    backgroundColor: theme.gridBGColor,
    width: "100%",
    height: "500px",
  },
  imagesContainer: {
    backgroundColor: theme.gridBGColor,
    width: "100%",
    height: "100%",
  },
  title: {
    color: theme.HeaderSelectedText,
    padding: "5px 15px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  content: {
    color: theme.TextColor,
    padding: "0px",
  },
  gridContainer: {
    height: "450px",
  },
  imagesGridContainer: {
    height: "100%",
    display: "flex"
  },
  imageListContainer: {
    flex: "0 0 200px",
    borderRight: "1px solid #e0e0e0",
    overflow: "auto"
  },
  imageContainer: {
    flex: 1,
    padding: "16px",
    overflow: "auto"
  },
  UNRTDShipmentGridContainer: {
    height: "445px",
    "& .statusBar": {
      borderTop: `1px solid ${theme.AppBGColor}`,
      margin: "0px",
      padding: "10px",
    },
  },
  dialog: {
    padding: "18px 24px",
    boxSizing: "border-box",
    borderRadius: "2px",
    backgroundColor: theme.ModalBGColor,
    boxShadow: "2px 2px 4px black",
    width: 400,
    userSelect: "none",
  },
  dialogTitle: {
    fontSize: 14,
    fontWeight: "600",
    lineHeight: "20px",
    color: theme.HeaderSelectedText,
    padding: 0,
  },
  dialogContent: {
    fontSize: theme.textFontSize,
    color: theme.TextColor,
    overflow: "hidden",
    padding: "16px 0px",
  },
  button: {
    fontSize: 14,
    textTransform: "none",
    borderRadius: "2px",
    margin: 0,
    width: "47%",
  },
  dialogAction: {
    justifyContent: "space-between",
    margin: 0,
    "&$lassoDialogAction": {
      paddingBottom: 0,
      paddingRight: 0,
    },
  },
  closeIcon: {
    float: "right",
    color: theme.iconColor,
    "&:hover": {
      color: theme.HeaderSelectedText,
    },
  },
  editorContainer: {
    "&>div": {
      marginTop: 0,
    },
  },
  inputError: {
    "&>div": {
      borderColor: theme.ErrorMessageColor,
      width: "100%",
    },
  },
  errorMessage: {
    color: theme.ErrorMessageColor,
    textAlign: "end",
  },
  lassoDialogAction: {
    margin: 0,
    padding: 0,
    display: "flex",
    justifyContent: "space-between",
  },
  noData:{
    alignSelf: "center",
    flex: 1,
    textAlign: "center",
    color: theme.gridTextColor,
  },
  headerContainer: {
    display: "flex",
    justifyContent: "space-between",
    padding: "4px 8px 8px 32px",
    alignItems: "center",
    borderBottom: `1px solid ${theme.AppBGColor}`,
  },
  refreshButton: {
    marginRight: 4,
    "& span": {
      marginLeft: 4,
    },
  },
  tabsContainer: {
    borderBottom: `1px solid ${theme.AppBGColor}`,
    minHeight: "48px",
  },
  tabPanel: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
  },
});

export default styles;
